export default __webpack_public_path__ + "static/media/pl.de38a616.svg";